var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDaySun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.955,
    height: 47.957,
    viewBox: "0 0 47.955 47.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3587.086 -309.518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3626.043,333.15a15.573,15.573,0,1,1-15.573-15.573A15.572,15.572,0,0,1,3626.043,333.15Z",
    transform: "translate(4.5 5.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3626.043,333.15a15.573,15.573,0,1,1-15.573-15.573A15.572,15.572,0,0,1,3626.043,333.15Z",
    transform: "translate(0.15 1.323)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3602.934,315.623l2.075-5.343a1.194,1.194,0,0,1,2.246.055l1.783,5.342a1.2,1.2,0,0,1-1.134,1.572h-3.858A1.193,1.193,0,0,1,3602.934,315.623Z",
    transform: "translate(8.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3593.189,331.639l-5.341-2.078a1.194,1.194,0,0,1,.055-2.246l5.342-1.78a1.194,1.194,0,0,1,1.572,1.132v3.857A1.2,1.2,0,0,1,3593.189,331.639Z",
    transform: "translate(0 9.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3594.569,321.284l-2.309-5.246a1.194,1.194,0,0,1,1.627-1.549l5.037,2.516a1.2,1.2,0,0,1,.31,1.913l-2.728,2.728A1.194,1.194,0,0,1,3594.569,321.284Z",
    transform: "translate(2.892 2.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3599.081,340.339l-5.246,2.307a1.194,1.194,0,0,1-1.548-1.627l2.518-5.039a1.2,1.2,0,0,1,1.913-.309l2.728,2.73A1.194,1.194,0,0,1,3599.081,340.339Z",
    transform: "translate(2.892 14.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3617.906,321.512l2.306-5.246a1.2,1.2,0,0,0-1.629-1.549l-5.032,2.521a1.193,1.193,0,0,0-.31,1.911l2.727,2.727A1.194,1.194,0,0,0,3617.906,321.512Z",
    transform: "translate(14.725 2.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3626.043,333.15a15.573,15.573,0,1,1-15.573-15.573A15.572,15.572,0,0,1,3626.043,333.15Z",
    transform: "translate(4.457 4.599)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaySun);
export default __webpack_public_path__ + "static/media/daySun.2aba1bb0d7914c6d37b899c56493f5c3.svg";
export { ForwardRef as ReactComponent };